import React from 'react';
import {RootState} from "../../../../../../reducers";
import {getCart} from "../../../../../services/Cart/reducer";
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {OrderType} from "../../../../../services/Api/types";
import {getStoreConfig} from "../../../../../services/Store/reducer";
import {ReactComponent as PickUpSVG} from "../../../../../../images/icons/pick-up.svg";

interface OwnProps {
    loading: boolean;
    orderType: OrderType;
    handleChangeType: (
        event: any,
        value?: string,
    ) => Promise<void>;
    handleOnTypeLabelKeyDown: (
        orderType: string,
    ) => (event: (React.KeyboardEvent<HTMLLabelElement> | KeyboardEvent)) => Promise<void>;
    drawOpenHours: (
        orderType: OrderType,
    ) => JSX.Element;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const CartPagePickUpOption = ({
                                  handleOnTypeLabelKeyDown,
                                  cart,
                                  loading,
                                  orderType,
                                  handleChangeType,
                                  config,
                                  drawOpenHours
                              }: Props) => {
    const {t} = useTranslation();
    const checked = orderType === OrderType.PICK_UP;

    if (config?.ordering.takeaway || orderType === OrderType.PICK_UP) {
        return (
            <label onKeyDown={handleOnTypeLabelKeyDown(OrderType.PICK_UP)} tabIndex={0} aria-checked={checked}
                   className={`btn btn-default btn-lg btn-check-full btn-spinner${(cart.pending || loading) ? " loading" : ""}${orderType === OrderType.PICK_UP ? " active" : ""}`}>
                <PickUpSVG/>
                <span>
                    <p className="mb-0">{t("enums.order.type.PICK_UP")}</p>
                    {drawOpenHours(OrderType.PICK_UP)}
                </span>
                <input className="btn-check1" type="radio" name="type" value={OrderType.PICK_UP} autoComplete="off"
                       tabIndex={-1} checked={checked} onChange={handleChangeType}/>
                <div className="spinner-border spinner-border-sm"/>
            </label>
        )
    }

    return <></>;
}

const mapStateToProps = (state: RootState) => ({
    cart: getCart(state.cart),
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartPagePickUpOption));
